import { render } from "./LabComponent.vue?vue&type=template&id=3efb3b57&scoped=true"
import script from "./LabComponent.vue?vue&type=script&lang=js"
export * from "./LabComponent.vue?vue&type=script&lang=js"

import "./LabComponent.vue?vue&type=style&index=0&id=3efb3b57&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efb3b57"]])

export default __exports__